<template>
  <div class="rule-conditions-wrapper">
    <div class="row rule-conditions" v-for="(row, i) in localModel" :key="i">

      <!--Field 1-->
      <b-form-group
        :state="$_hasError('field1-' + i)"
        :class="`${$_value(row.field1).type !== 'hour_of_day' ? $c_colsClassName.field1 : ''} col-sm-12 field1 optimizer-form-group`"
      >
        <b-input-group :prepend="i === 0 ? 'IF' : 'AND'" :append="row.field1 && $_value(row.field1).behind || 'IS'">
          <vue-opti-select-light
            class="optimizer-select w-100"
            data-vv-as="Type"
            v-validate="'required'"
            data-vv-validate-on="input|update"
            :name="'field1-' + i"
            :key="'field1-' + i"
            v-model="row.field1"
            :options="$c_field1Options"
            :groups="optionsData.fieldsGroup"
            :unique-key="option => option.value.key"
            label-key="text"
            single
            searchable
            button-block
            @change="(item) => $_changeField1(row, item)"
          >
            <template #ITEM="{option}">
              <field-tooltip :option="option" :info="option.description" />
            </template>
          </vue-opti-select-light>
        </b-input-group>
        <small slot="invalid-feedback">{{ $_getError('field1-' + i) }}</small>
      </b-form-group>

      <template v-if="$_value(row.field1).type === 'hour_of_day'">
        <!--Hour of Day field-->
        <b-form-group class="col-sm-12 day-of-hour-form-group optimizer-form-group">
          <scheduler v-model="row.field3.value" ref="hourOfDay" />
          <div v-if="!cmp_config.disable_buttons" class="day-of-hour-remove-button">
            <button @click.prevent="$_removeAction(i)" class="btn btn-secondary hide-rule-row-btn">
              <i class="fa fa-close"></i>
            </button>
          </div>
        </b-form-group>
      </template>

      <template v-else-if="$_value(row.field1).type === 'daily_cap'">
        <b-form-group class="col-sm-4 optimizer-form-group">
          <b-input-group>
            <vue-opti-select-light
              class="optimizer-select w-100"
              data-vv-as="Condition"
              v-validate="'required'"
              data-vv-validate-on="input|update"
              :name="'field2-' + i"
              :key="'field2-' + i"
              v-model="row.field2"
              :options="optionsData.conditionsDailyCap"
              :unique-key="option => option.value.key"
              label-key="text"
              single
              searchable
              button-block
            />
          </b-input-group>
        </b-form-group>
      </template>
      <template v-else-if="$_isTextField($_value(row.field1).key)">
        <b-form-group :state="$_hasError('field2-' + i)" :class="`${$c_colsClassName.field2} col-sm-12 optimizer-form-group`">
          <b-input-group>
            <vue-opti-select-light
              class="optimizer-select w-100"
              data-vv-as="Condition"
              v-validate="'required'"
              data-vv-validate-on="input|update"
              :name="'field2-' + i"
              :key="'field2-' + i"
              :options="optionsData.nameConditions"
              v-model="row.field2"
              :unique-key="option => option.value.key"
              label-key="text"
              single
              searchable
              button-block
            />
          </b-input-group>
          <small slot="invalid-feedback">{{ $_getError('field2-' + i) }}</small>
        </b-form-group>
        <b-form-group :state="$_hasError('field3-' + i)" :class="`${$c_colsClassName.field3} col-sm-12 field3 optimizer-form-group`">
          <b-input-group>
            <template>
              <b-form-input
                class="field3-input optimizer-form-input"
                data-vv-as="Value"
                v-validate="'required'"
                type="text"
                v-model="row.field3.value"
                :name="'field3-' + i"
              >
              </b-form-input>
            </template>

            <div v-if="!$c_enableToFields && $_value(row.field1).placeholderHtml" v-html="$_value(row.field1).placeholderHtml" class="input-group-addon text-center" style="border-right: 1px solid #e1e6ef;display: block;"></div>
            <div v-if="!cmp_config.disable_buttons" style="margin-left: 14px;" class="input-group-button">
              <button @click.prevent="$_removeAction(i)" class="btn btn-secondary hide-rule-row-btn">
                <i class="fa fa-close"></i>
              </button>
            </div>
          </b-input-group>
          <small slot="invalid-feedback">{{ $_getError('field3-' + i) }}</small>
        </b-form-group>
      </template>

      <template v-else-if="$_isStatusField($_value(row.field1).key)">
        <b-form-group :state="$_hasError('field3-' + i)" :class="`col-md-8 optimizer-form-group`">
          <b-input-group class="w-100">
            <vue-opti-select-light
              class="optimizer-select col-md-4 pl-0"
              data-vv-as="Condition"
              v-validate="'required'"
              data-vv-validate-on="input|update"
              :name="'field3-' + i"
              :key="'field3-' + i"
              v-model="row.field3"
              :options="optionsData.statusConditions"
              :unique-key="option => option.value.key"
              label-key="text"
              single
              searchable
              button-block
            />
            <div v-if="!cmp_config.disable_buttons" style="margin-left: auto;" class="input-group-button">
              <button @click.prevent="$_removeAction(i)" class="btn btn-secondary hide-rule-row-btn">
                <i class="fa fa-close"></i>
              </button>
            </div>
          </b-input-group>
          <small slot="invalid-feedback">{{ $_getError('field2-' + i) }}</small>
        </b-form-group>
      </template>

      <template v-else-if="$_isLearningState($_value(row.field1).key)">
        <b-form-group :state="$_hasError('field3-' + i)" :class="`col-md-8 optimizer-form-group`">
          <b-input-group class="w-100">
            <vue-opti-select-light
              class="optimizer-select col-md-4 pl-0"
              data-vv-as="Condition"
              v-validate="'required'"
              data-vv-validate-on="input|update"
              :name="'field3-' + i"
              :key="'field3-' + i"
              v-model="row.field3"
              :options="optionsData.learningStateConditions"
              :unique-key="option => option.value.key"
              label-key="text"
              single
              button-block
            />
            <div v-if="!cmp_config.disable_buttons" style="margin-left: auto;" class="input-group-button">
              <button @click.prevent="$_removeAction(i)" class="btn btn-secondary hide-rule-row-btn">
                <i class="fa fa-close"></i>
              </button>
            </div>
          </b-input-group>
          <small slot="invalid-feedback">{{ $_getError('field2-' + i) }}</small>
        </b-form-group>
      </template>

      <template v-else>
        <!--Condition field-->
        <b-form-group :state="$_hasError('field2-' + i)" :class="`${$c_colsClassName.field2} col-sm-12 optimizer-form-group`">
          <b-input-group :append="row.field2 && row.field2.behind || 'THAN'">
            <vue-opti-select-light
              class="optimizer-select w-100"
              data-vv-as="Condition"
              v-validate="'required'"
              data-vv-validate-on="input|update"
              :name="'field2-' + i"
              :key="'field2-' + i"
              v-model="row.field2"
              :options="optionsData.conditions"
              :unique-key="option => option.value.key"
              label-key="text"
              single
              searchable
              button-block
            />
          </b-input-group>
          <small slot="invalid-feedback">{{ $_getError('field2-' + i) }}</small>
        </b-form-group>

        <!--Condition value-->
        <b-form-group :state="$_hasError('field3-' + i)" :class="`${$c_colsClassName.field3} col-sm-12 field3 optimizer-form-group`">
          <b-input-group>
            <time-input
              v-if="$_value(row.field1).type === 'time'"
              v-model.number="row.field3.value"
            />
            <template v-else>
              <b-form-input
                class="field3-input optimizer-form-input"
                data-vv-as="Value"
                v-validate="'required'"
                type="number"
                :step="$_value(row.field1).step ? $_value(row.field1).step : 1"
                v-model.number="row.field3.value"
                data-vv-validate-on="change"
                :name="'field3-' + i"
              >
              </b-form-input>
              <template v-if="$c_enableToFields">
                <vue-opti-select-light
                  class="optimizer-select field3-unit"
                  :value="row.field3.unit"
                  @change="(option) => { row.field3.unit = option.value }"
                  :options="$_getToUnitOptions(row.field1)"
                  label-key="text"
                  single
                />
                <vue-opti-select-light
                  v-if="row.field3.unit === 'percentage'"
                  :class="[{ 'has-error': $_hasError('field3-to-' + i) === false }, 'optimizer-select']"
                  data-vv-as="Campaign Type"
                  v-validate="'required'"
                  data-vv-validate-on="input|update"
                  :name="'field3-to-' + i"
                  :key="'field3-to-' + i"
                  v-model="row.field3.to"
                  :options="$c_fieldsToOptions"
                  :groups="optionsData.fieldsGroup"
                  :unique-key="option => option.value.key"
                  label-key="text"
                  single
                  searchable
                  button-block
                  @change="(item) => $_changeFieldTo(row, item)"
                >
                  <template #ITEM="{option}">
                    <field-tooltip :option="option" :info="option.description" />
                  </template>
                </vue-opti-select-light>
                <vue-opti-select-light
                  v-else-if="row.field3.unit === 'self'"
                  :class="[{ 'has-error': $_hasError('field3-to-self-' + i) === false }, 'optimizer-select']"
                  data-vv-as="Campaign Type"
                  v-validate="'required'"
                  data-vv-validate-on="input|update"
                  :name="'field3-to-self-' + i"
                  :key="'field3-to-self-' + i"
                  v-model="row.field3.to_self"
                  :options="$c_fieldToSelfOptions"
                  :groups="optionsData.fieldsGroup"
                  :unique-key="option => option.value.key"
                  label-key="text"
                  single
                  searchable
                  button-block
                >
                  <template #ITEM="{option}">
                    <field-tooltip :option="option" :info="option.description" />
                  </template>
                </vue-opti-select-light>
              </template>

            </template>

            <div v-if="!$c_enableToFields && $_value(row.field1).placeholderHtml" v-html="$_value(row.field1).placeholderHtml" class="input-group-addon text-center" style="border-right: 1px solid #e1e6ef;display: block;"></div>
            <div v-if="!cmp_config.disable_buttons" style="margin-left: 14px;" class="input-group-button">
              <button @click.prevent="$_removeAction(i)" class="btn btn-secondary hide-rule-row-btn">
                <i class="fa fa-close"></i>
              </button>
            </div>
          </b-input-group>
          <small slot="invalid-feedback">{{ $_getError('field3-' + i) }}</small>
        </b-form-group>
      </template>
    </div>

    <div v-if="customValidations.length">
      <small class="text-danger d-block my-1" v-for="(error, errIndex) in customValidations" :key="errIndex">{{ error }}</small>
    </div>

    <div class="row pb-0" v-if="!cmp_config.disable_buttons">
      <div class="col">
        <b-btn variant="primary" class="secondary-button" @click.prevent="$_addAction">
          <i class="fa fa-plus"></i> Add
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import component from '../mixins/component';
import TimeInput from './subcomponents/TimeInput';
import Scheduler from './subcomponents/Scheduler';
import _ from 'lodash';
import FieldTooltip from '../../../components/Utils/FieldTooltip.vue';

export default {
  name: 'RuleConditions',
  // eslint-disable-next-line vue/no-unused-components
  components: { TimeInput, Scheduler, FieldTooltip },
  mixins: [component],
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      cmp_config: this.ruleModel.rule.components.conditions,
      localModel: [{ field1: null, field2: null, field3: { value: '', unit: 'static', to: null } }],
      model: [],
      optionsData: {
        fieldsGroup: this.config.conditionsConfig.fieldsGroup.map((group) => ({ ...group, content: group.label })),
        fields: _.cloneDeep(this.config.conditionsConfig.fields),
        conditions: this.config.conditionsConfig.conditions,
        nameConditions: this.config.conditionsConfig.nameConditions,
        learningStateConditions: this.config.conditionsConfig.learningStateConditions,
        statusConditions: this.config.conditionsConfig.statusConditions,
        toFields: _.cloneDeep(this.config.conditionsConfig.toFields),
        conditionsDailyCap: this.config.conditionsConfig.conditionsDailyCap,
        campaignOnlyFields: ['target_cpa', 'payout'],
        placementsNotAllowedGroups: ['tr', 'ga', 'ga4', 'cc', 'cm', 'pf', 'amazondsp', 'ayf'],
      },
      customValidations: [],
      test: '',
    };
  },
  computed: {
    $c_field1Options() {
      let options = [];
      const exeptions = {};
      if (this.cmp_config.except) this.cmp_config.except.forEach((key) => { exeptions[key] = true; });
      this.optionsData.fields.forEach((field) => {
        if (!this.cmp_config.filter_fields || this.cmp_config.filter_fields.includes(field.value.key)) {
          if (!exeptions[field.value.key]) {
            options.push({ ...field, inputGroup: field.group });
          }
        }
      });
      const optionsMappedByKey = options.reduce((obj, option) => Object.assign(obj, { [option.value.key]: option }), {});
      const foundCampaignOnlyFields = this.optionsData.campaignOnlyFields.filter((field) => optionsMappedByKey[`campaign_${field}`] !== undefined);
      const isFacebookCase = ['Widget', 'Domain', 'Exchange'].includes(this.ruleModel.rule.level) && this.ruleModel.rule.ts_types.length === 1 && this.ruleModel.rule.ts_types.includes('Facebook');
      if (isFacebookCase) {
        options = options.filter((option) => !this.optionsData.placementsNotAllowedGroups.includes(option.group));
      }
      return options.filter((option) => !foundCampaignOnlyFields.includes(option.value.key));
    },
    $c_fieldToSelfOptions() {
      return this.$c_field1Options.filter((option) => !option.notAvailableForToComparison && (option.value.key !== 'hour_of_day' && option.group !== 'campaign'));
    },
    $c_enableToFields() {
      try {
        return !!this.optionsData.toFields.length;
      } catch (err) {
        return false;
      }
    },
    $c_fieldsToOptions() {
      if (this.$c_enableToFields) {
        const options = [];
        this.optionsData.toFields.forEach((field) => {
          options.push({ ...field, inputGroup: field.group });
        });
        return options;
      }
      return [];
    },
    $c_colsClassName() {
      const cols = { field1: 'col-md-5', field2: 'col-md-4', field3: 'col-md-3' };
      if (this.$c_enableToFields) {
        cols.field1 = 'col-md-4';
        cols.field2 = 'col-md-3';
        cols.field3 = 'col-md-5';
      }
      return cols;
    },
  },
  watch: {
    localModel: {
      immediate: true,
      handler(localModel) {
        /** ************ Limit Once Hour of Day ************* */
        const key = 'hour_of_day';
        const row = localModel.find((item) => this.$_value(item.field1).key === key);
        const option = this.optionsData.fields.find((item) => item.value.key === key);
        if (option) option.disabled = !!row;
        /** ************************************************* */
        /** ***************** Set Model ********************* */
        const model = [];
        localModel.forEach((item) => {
          if (this.$_value(item.field1)) {
            const modelItem = {};
            if (this.$_value(item.field1).type === 'daily_cap') {
              modelItem.today_ts_clicks = {};
              modelItem.today_ts_clicks.condition = this.$_value(item.field2).key;
              modelItem.today_ts_clicks.value = 100;
              modelItem.today_ts_clicks.to_self = 'static';
              modelItem.today_ts_clicks.to = 'daily_cap';
              model.push(modelItem);
              return;
            }
            modelItem[this.$_value(item.field1).key] = {
              value: typeof item.field3 !== 'undefined' ? item.field3.value : '',
            };
            try {
              modelItem[this.$_value(item.field1).key].condition = item.field2.value.key;
            } catch (err) {
              modelItem[this.$_value(item.field1).key].condition = null;
            }
            try {
              modelItem[this.$_value(item.field1).key].to = item.field3.unit === 'percentage' ? item.field3.to.value.key : 'static';
              modelItem[this.$_value(item.field1).key].to_self = item.field3.unit === 'self' ? item.field3.to_self.value.key : 'static';
            } catch (err) {
              modelItem[this.$_value(item.field1).key].to = 'static';
              modelItem[this.$_value(item.field1).key].to_self = 'static';
            }
            model.push(modelItem);
          }
        });
        this.model = model;
        /** ************************************************* */
      },
      deep: true,
    },
    model: {
      immediate: true,
      handler() {
        this.$_emit('model');
      },
      deep: true,
    },
  },
  created() {
    if (this.value.length) {
      /** ********** Set LocalModel ************* */
      const fields1Map = {};
      this.optionsData.fields.forEach((item) => { fields1Map[item.value.key] = item; });
      const fields2Map = {};
      this.optionsData.conditions.forEach((item) => { fields2Map[item.value.key] = item; });
      this.optionsData.nameConditions?.forEach((item) => { fields2Map[item.value.key] = item; });
      // Name Options
      const fields3Map = {};
      this.optionsData.statusConditions?.forEach((item) => { fields3Map[item.value.key] = item; });
      this.optionsData.learningStateConditions?.forEach((item) => { fields3Map[item.value.key] = item; });
      const localModel = [];
      this.value.forEach((obj) => {
        const key = Object.keys(obj)[0];
        const item = obj[key];
        // Set Campaign To Option
        let unit = 'static';
        if (item.to && item.to !== 'static') {
          unit = 'percentage';
        } else if (item.to_self && item.to_self !== 'static') {
          unit = 'self';
        }
        // const unit = item.to && item.to !== 'static' ? item.to : 'static';
        let to = null;
        let to_self = null;
        if (unit === 'percentage') {
          const BreakException = {};
          try {
            this.$c_fieldsToOptions.forEach((option) => {
              if (option.value.key === item.to) {
                to = option;
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }
        } else if (unit === 'self') {
          const BreakException = {};
          try {
            this.$c_fieldToSelfOptions.forEach((option) => {
              if (option.value.key === item.to_self) {
                to_self = option;
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }
        }
        localModel.push({
          field1: fields1Map[key] || null,
          field2: fields2Map[item.condition] || null,
          field3: key === 'status' || key === 'learning_state' ? fields3Map[item.value] : { value: item.value, unit, to, to_self },
        });
      });
      this.localModel = localModel;
      /** *************************************** */
    }
    this.$options.unitOptions = [{ value: 'static', text: '...' }, { value: 'percentage', text: '% of campaign' }];
    if (this.$platform === 'native') this.$options.unitOptions.push({ value: 'self', text: '% of' });
  },
  methods: {
    async validate(force) {
      try {
        const forms = [this.$validator.validateAll(), this.$_validateCustom(force)];
        if (this.$refs.hourOfDay && this.$refs.hourOfDay.length > 0) forms.push(...this.$refs.hourOfDay.map((hod) => hod.validate()));
        const validationForms = await Promise.all(forms);
        const valid = validationForms.reduce((status, formStatus) => status && formStatus, true);
        return valid;
      } catch (error) {
        return false;
      }
    },
    $_validateCustom(force) {
      this.customValidations = [];
      if (this.$_getValidationRule('no_alone_scheduler', force)) {
        if (this.localModel.length < 2) {
          let field1 = '';
          try {
            field1 = this.localModel[0].field1.value.key;
          } catch (err) {
            // Nothing
          }
          if (field1 === 'hour_of_day') this.customValidations.push('You need to select at least one more condition! Rules with only time condition are not allowed.');
        }
      }
      return this.customValidations.length === 0;
    },
    $_removeAction(index) {
      if (this.localModel.length > 1) this.localModel.splice(index, 1);
    },
    async $_addAction() {
      if (await this.validate({ no_alone_scheduler: false })) {
        this.localModel.push({
          field1: null,
          field2: null,
          field3: { value: '', unit: 'static', to: null, to_self: null },
          field4: null,
        });
      }
    },
    $_isTextField(field) {
      return !!['name', 'headline', 'campaign_name'].includes(field);
    },
    $_isStatusField(field) {
      return field === 'status';
    },
    $_isLearningState(field) {
      return field === 'learning_state';
    },
    $_changeField1(row, selected) {
      // Custom conversion
      if (selected && selected.group === 'cc') {
        const ccTrackeId = selected.value.key.split('::')[1];
        if (ccTrackeId) {
          this.localModel.forEach((item) => {
            if (item.field1 && item.field1.group === 'cc' && item.field1.value.key.indexOf('::') > -1) {
              if (item.field1.value.key.indexOf(ccTrackeId) === -1) {
                item.field1 = null;
              }
            }
          });
        }
      }
      row.field2 = null;
      row.field3 = { value: '', unit: 'static', to: null, to_self: null };
    },
    $_changeFieldTo(row, selected) {
      try {
        if (selected.value.key === 'payout') {
          // Alert Once
          const findPayout = this.localModel.find((_row) => {
            try {
              return _row.field3.to.value.key === 'payout';
            } catch (err) { return false; }
          });
          if (!findPayout) {
            this.$nextTick(() => {
              this.$swal({
                type: 'warning',
                title: 'Campaign payout selected',
                text: 'This rule will NOT be executed on campaigns for which a payout is not set ( Payout = $0 ). Please make sure to manually set a payout for all campaigns in this rule that have payout=$0',
              });
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    $_value(obj) {
      try {
        return obj.value || {};
      } catch (err) {
        return {};
      }
    },
    $_getValidationRule(name, force) {
      if (this.cmp_config['v-validate'] && typeof this.cmp_config['v-validate'][name] !== 'undefined') {
        return force && typeof force[name] !== 'undefined' ? force[name] : this.cmp_config['v-validate'][name];
      }
      return null;
    },
    $_getToUnitOptions(field1) {
      const options = this.$options.unitOptions.map((option) => {
        if (option.value === 'static') {
          try {
            return { ...option, text: this.config.conditionsConfig.fieldsMap[field1.value.key].value.placeholder || '...' };
          } catch (err) {
            // Nothing
          }
        }
        return option;
      });
      if (field1?.group === 'campaign') {
        return options.filter((option) => !['percentage', 'self'].includes(option.value));
      }
      return options;
    },
  },
};
</script>

<style lang="scss">


.rule-conditions-wrapper {
  .rule-conditions {
    margin-bottom: 2.5rem;
  }

  .optimizer-select {
    &.has-error .btn.dropdown-toggle {
      border-color: #ff5454;
    }
  }

  .optimizer-form-group {
    &.field1 {
      .input-group {
        &-prepend {
          .input-group-text {
            &::first-letter {
              text-transform: uppercase;
            }
          }
        }
      }
    }

    &.field3 {
      .optimizer-form-input {
        min-width: 8rem;
      }

      .field3-unit {
        max-width: 15rem;
        min-width: 14rem;
      }

      .optimizer-select {
        width: 30rem;
        margin-left: 1rem;
      }
    }

    .input-group {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;

      &-prepend,
      &-append {
        min-width: 4rem;
        display: flex;
        justify-content: center;

        .input-group-text {
          background: transparent;
          border: none;
          display: block;
          font-size: 1.5rem;
          text-transform: lowercase;
          color: $text-primary;
          font-weight: bold;
        }
      }

      &-prepend {
        margin-right: .5rem;
      }

      &-append {
        margin-left: 1rem;
      }

      input {
        border-top-right-radius: .6rem;
        border-bottom-right-radius: .6rem;
      }
    }
  }

  .hide-rule-row-btn {
    background: #E4EAEE;
    border-radius: .6rem;
    color: #546582;
    font-size: 1.5rem;
    padding: .5rem 1rem;
    border: none;

    &:hover,
    &:active,
    &:focus {
      background: #E4EAEE !important;
      color: #546582 !important;
    }
  }

  .add-rule-row {

  }

  .row {
    margin: -7px !important;
    padding-bottom: 1rem;

    & > * {
      padding: 7px;
    }
  }
  .form-group {
    margin-bottom: 0px;

    .input-group-addon {
      font-weight: bold;
      color: #99979c;
      font-size: 10px;
      line-height: 15px;
      text-align: center;
      display: block;
    }

    &.day-of-hour-form-group {
      & > div[role=group] {
        position: relative;
        > .form-control {
          padding-top: 10px;
        }
      }
      .dropdown-menu {
        z-index: 999999;
      }
      .day-of-hour-remove-button {
        display: block;
        position: absolute;
        top: 1.3rem;
        right: 0;
        padding: 0px 0px 5px 5px;
        background-color: #FFF;
      }
      .hour-of-day-wrapper table thead > tr {
        line-height: 31px;
      }
    }
  }
}
</style>
